/** Shared preload for the product photograph shown on all homepages. */
import websiteImage from "@/assets/concept-website.webp";

export const heroPortraitPreload = {
  rel: "preload",
  as: "image",
  type: "image/webp",
  href: websiteImage,
  fetchPriority: "high",
} as const;
